import { render, staticRenderFns } from "./ConcernKeywordsNewsListItem.vue?vue&type=template&id=4d865d14&scoped=true"
import script from "./ConcernKeywordsNewsListItem.vue?vue&type=script&lang=js"
export * from "./ConcernKeywordsNewsListItem.vue?vue&type=script&lang=js"
import style0 from "./ConcernKeywordsNewsListItem.vue?vue&type=style&index=0&id=4d865d14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d865d14",
  null
  
)

export default component.exports